import React from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useProviderCalendar, nowDate } from './useProviderCalendar';
import { renderAddress } from '../../helpers/renderAddress';
import TimeSlots from '../../Components/TimeSlots';
import Calendar from '../../../common/Calendar';
import Loader from '../../../common/Loader';
import Shape from '../../../common/Shape';
import Icon from '../../../Icon';
import styles from './styles.styl';

function ProviderCalendar({ onDateChange, onTimeSelect, isOfficeVisit }) {
  const {
    availableLocationsByProvider,
    formatCurrentDate,
    handleDateChange,
    displayableTime,
    startDate,
    loading,
  } = useProviderCalendar(onDateChange);

  return (
    <Shape styleName="root">
      <div styleName="left">
        <Calendar
          disabled
          minDate={nowDate}
          onChange={handleDateChange}
          selected={startDate}
          inline
        />
      </div>
      <div styleName="right">
        <div styleName="time-title">{displayableTime}</div>
        {loading && <Loader />}
        {!loading && (
          <div className={styles.locationWrapper}>
            {availableLocationsByProvider.length > 0 ? (
              availableLocationsByProvider.map(location => {
                const slotsSource = location.providers[0].timeSlotsSource;
                return (
                  <div className={styles.content} key={location.id}>
                    <div className={styles.locationHeader}>
                      <div className={styles.locationName}>
                        <Icon name="pin-location-fill-black" size={12} />
                        {location.name}
                      </div>
                      {isOfficeVisit && (
                        <div className={styles.locationAddress}>
                          {renderAddress(location)}
                        </div>
                      )}
                    </div>

                    <TimeSlots
                      variant="sm"
                      list={location.providers[0].timeSlots}
                      onSelect={slot =>
                        onTimeSelect(
                          slot,
                          location,
                          slotsSource,
                          formatCurrentDate,
                        )
                      }
                    />
                  </div>
                );
              })
            ) : (
              <div styleName="emptyList">
                <FormattedMessage id="appointments.form.noAvailableProviders" />
              </div>
            )}
          </div>
        )}
      </div>
    </Shape>
  );
}

ProviderCalendar.propTypes = {
  onDateChange: PropTypes.func,
  onTimeSelect: PropTypes.func,
  isOfficeVisit: PropTypes.bool,
};

export default CSSModules(ProviderCalendar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentProviderDetails/ProviderCalendar/index.jsx